import React from "react";
import LoginComponent from "./loginComponent";
import {
  authServiceInstance,
  useExternalLoginProviders,
  externalLoginProviderName,
} from "../General/globals";
import { ownStore } from "../AppOwnState/ownState";
import { ExecuteLayoutEventMethods } from "../General/commonFunctions";
import { showAppBusy, hideAppBusy } from "../AppOwnState";
import { ShowSnackBar } from "../General/globalFunctions";
import { GoogleLogin } from "@react-oauth/google";
import { useMsal } from "@azure/msal-react";

const LoginModal = ({ sessionOut, authEmail }) => {
  const { instance, accounts } = useMsal();

  const doSignInSSO = async (email, token) => {
    try {
      window.history.pushState(null, "Home", "/");
      ownStore.dispatch(showAppBusy());
      await authServiceInstance.SSOlogin(email, token);
      const authOK = await authServiceInstance.verifyLogin();
      if (authOK?.status) {
        if (authOK?.doNext) {
          ownStore.dispatch(hideAppBusy());
          try {
            const authEvents = JSON.parse(authOK.doNext);
            await ExecuteLayoutEventMethods(authEvents);
          } catch {}
          return;
        }
        authServiceInstance.continueLogin();
        return;
      }
    } catch (ex) {
      console.error(ex);
    }
    ownStore.dispatch(hideAppBusy());
    ShowSnackBar("error", "Login Failed!");
  };

  const MSALlogin = async () => {
    const loginResponse = await instance.loginPopup({
      scopes: ["User.Read"],
    });

    const tokenResponse = await instance.acquireTokenSilent({
      account: loginResponse.account,
      scopes: ["User.Read"],
    });

    const res = await fetch("https://graph.microsoft.com/v1.0/me", {
      headers: {
        Authorization: `Bearer ${tokenResponse.accessToken}`,
      },
    });
    const profile = await res.json();
    await doSignInSSO(profile.mail, tokenResponse.idToken);
  };

  const handleLoginSuccess = async (credentialResponse) => {
    // console.log("Google Credential Response:", credentialResponse);
    await doSignInSSO(null, credentialResponse.credential);
  };
  const handleLoginError = () => {
    console.error("Login Failed");
  };
  return useExternalLoginProviders ? (
    <>
      {externalLoginProviderName === "GOOGLE" && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            width: "100%",
            position: "fixed",
            top: 0,
            left: 0,
            background: "rgba(0,0,0,0.6)",
            zIndex: 10000,
            fontFamily: "Segoe UI, sans-serif",
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #f0f4ff, #d9e4ff)",
              padding: "40px 35px",
              borderRadius: "15px",
              boxShadow: "0 12px 30px rgba(0,0,0,0.2)",
              textAlign: "center",
              minWidth: "320px",
              maxWidth: "400px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
            }}
          >
            <h2
              style={{
                margin: 0,
                color: "#1a1a1a",
                fontSize: "22px",
                fontWeight: "600",
              }}
            >
              Session Expired!
            </h2>
            <p
              style={{
                margin: 0,
                color: "#333",
                fontSize: "16px",
                lineHeight: "1.5",
              }}
            >
              Your session has expired. Please log in again to continue.
            </p>
            <GoogleLogin
              width={300}
              onSuccess={handleLoginSuccess}
              onError={handleLoginError}
            />
          </div>
        </div>
      )}

      {externalLoginProviderName === "MSAL" && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            width: "100%",
            position: "fixed",
            top: 0,
            left: 0,
            background: "rgba(0,0,0,0.6)",
            zIndex: 10000,
            fontFamily: "Segoe UI, sans-serif",
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #f0f4ff, #d9e4ff)",
              padding: "40px 35px",
              borderRadius: "15px",
              boxShadow: "0 12px 30px rgba(0,0,0,0.2)",
              textAlign: "center",
              minWidth: "320px",
              maxWidth: "400px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
            }}
          >
            <h2
              style={{
                margin: 0,
                color: "#1a1a1a",
                fontSize: "22px",
                fontWeight: "600",
              }}
            >
              Session Expired!
            </h2>
            <p
              style={{
                margin: 0,
                color: "#333",
                fontSize: "16px",
                lineHeight: "1.5",
              }}
            >
              Your session has expired. Please log in again to continue.
            </p>
            <button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "12px",
                padding: "12px 25px",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "500",
                borderRadius: "10px",
                border: "none",
                background: "linear-gradient(90deg, #0078D4, #00A0F1)",
                color: "#fff",
                transition: "all 0.3s ease",
              }}
              onClick={MSALlogin}
              onMouseOver={(e) =>
                (e.currentTarget.style.filter = "brightness(1.1)")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.filter = "brightness(1)")
              }
            >
              <img
                width="28px"
                height="28px"
                src="/Microsoft_logo.png"
                alt="Microsoft logo"
              />
              Login with Microsoft
            </button>
          </div>
        </div>
      )}
    </>
  ) : (
    <div
      style={{
        zIndex: "20000",
        position: "fixed",
        width: "100%",
        height: "100%",
        background: "#00000072",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          zIndex: "20001",
          background: "#fff",
          padding: "50px 30px",
          borderRadius: "10px",
        }}
      >
        <LoginComponent sessionOut={sessionOut} authEmail={authEmail} />
      </div>
    </div>
  );
};

export default LoginModal;
